import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { PressMarquee } from '../components/PressMarquee';
import { Reveal } from '../components/Reveal';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { pressItems } from '../data/press';
const groups: {
  label: string;
  types: string[];
}[] = [{
  label: 'Features & interviews',
  types: ['Feature', 'Interview']
}, {
  label: 'Podcasts',
  types: ['Podcast']
}, {
  label: 'Awards & recognition',
  types: ['Award']
}];
export function Press() {
  return <>
      <PageHeader eyebrow="Press & recognition" title="On the record." intro="Selected features, interviews, podcast conversations and recognition from across the global business press." data-id="element-421" data-mp="3rjuymniws46p" />

      <PressMarquee label="Coverage" data-id="element-422" data-mp="1bqnml4tz66np" />

      <section className="px-6 py-24 sm:px-10 sm:py-36" data-id="element-423" data-mp="1bpkwgz4h888u">
        <div className="mx-auto max-w-[92rem] space-y-24" data-id="element-424" data-mp="1scm7389iaswv">
          {groups.map(g => {
          const items = pressItems.filter(p => g.types.includes(p.type));
          if (!items.length) return null;
          return <div key={g.label} className="grid gap-10 lg:grid-cols-12" data-id="element-425" data-mp="1jb4s5t7u4x9r">
                <div className="lg:col-span-3" data-id="element-426" data-mp="1ed3ancq2560e">
                  <Reveal data-id="element-427" data-mp="1ecbeo0sjt69l">
                    <h2 className="eyebrow text-mocha" data-id="element-428" data-mp="1ef7clp4ebuy1">{g.label}</h2>
                  </Reveal>
                </div>
                <ul className="lg:col-span-9" data-id="element-429" data-mp="14na10h9h70ys">
                  {items.map((p, i) => <Reveal key={p.title} delay={i * 0.05} as="li" data-id="element-430" data-mp="10lg3ghukud2u" data-mpi={i}>
                      <a href="#" className="group grid grid-cols-1 items-baseline gap-2 border-t border-charcoal/[0.1] py-7 sm:grid-cols-12 sm:gap-6" data-id="element-431" data-mp="10lohwe6clqg5">
                        <span className="text-xs uppercase tracking-[0.16em] text-charcoal/40 sm:col-span-2" data-id="element-432" data-mp="qp3e1w62eldw">
                          {p.outlet}
                        </span>
                        <h3 className="font-serif text-[1.375rem] font-light leading-snug text-charcoal transition-colors duration-500 group-hover:text-mocha sm:col-span-8" data-id="element-433" data-mp="bz8nwanjcy9o">
                          {p.title}
                        </h3>
                        <span className="flex items-center gap-2 text-xs text-charcoal/40 sm:col-span-2 sm:justify-end" data-id="element-434" data-mp="71739lagoqw3">
                          {p.year}
                          <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-500 ease-editorial group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.4} data-id="element-435" data-mp="urtbpdodod6m" />
                        </span>
                      </a>
                    </Reveal>)}
                </ul>
              </div>;
        })}
        </div>
      </section>

      <div className="border-t border-charcoal/[0.08]" data-id="element-436" data-mp="1ihnmlpp4zro8">
        <TestimonialsSection data-id="element-437" data-mp="33715svvoq4ug" />
      </div>

      <CTASection data-id="element-438" data-mp="335zm630lsa14" />
    </>;
}